import gql from "graphql-tag";

/* Menu item with a URL, used to go to a separate page */
const menuSingleItem = gql`
  fragment MenuSingleItem on MenuItem {
    leftIcon
    text
    defaultMessage
    url
    checkPermissions {
      objects
      actions
    }
  }
`;

/**
 * GraphQL query to obtain main menu items that are used to navigate throughout the app.
 *
 * This query should be local and never query the server.
 */
export default gql`
  query MainMenu {
    MainMenu @client {
      visible
      items {
        leftIcon
        title
        defaultMessage
        collapsible
        expanded
        checkPermissions {
          objects
          actions
        }

        children {
          ...MenuSingleItem
        }
      }
    }
  }

  ${menuSingleItem}
`;
